if (typeof p80 === typeof undefined) {
	var p80 = {};
}

p80.announcementBar = function (config) {
	/****
	 *
	 * CONFIG
	 *
	 * {
	 *      slideDuration: integer || 10000 // determines how long we remain on each slide for
	 *      transitionDuration: integer || 500 // determines how long our transition between slides takes
	 * }
	 *
	 */

	this.config = {};
	// Holds how long we remain on each slide for
	this.config.slideDuration = config.slideDuration ? config.slideDuration : 10000;
	// Holds our transition duration which will dynamically append CSS
	this.config.transitionDuration = config.transitionDuration ? config.transitionDuration : 500;

	// Holds all our markup
	this.html = document.getElementById('shopify-section-announcement-bar');
	// Holds how many announcement bars we have in total
	this.totalSlides = 0;
	// Holds our current slide index
	this.currentSlide = 0;
	// Holds our previous slide index
	this.previousSlide = null;

	if (!this.html) {
		return;
	}

	// Holds all our slides
	this.slides = this.html.getElementsByClassName('announcement-bar');
	// Assign our total number of announcement bars to our variable
	this.totalSlides = this.slides.length;
	// Holds our interval for the slides
	this.interval = null;

	// No point intializing our rotation if we have one or less slides
	if (this.totalSlides <= 1) {
		return;
	}

	this.initialize();
};
p80.announcementBar.prototype.initialize = function () {
	const announcementBar = this;
	announcementBar.createCss();
	announcementBar.createInterval();
};
// Dynamically create transition duration CSS based on our transitionDuration configuration
p80.announcementBar.prototype.createCss = function () {
	const announcementBar = this;
	document.head.insertAdjacentHTML(
		'beforeend',
		`<style>
        .announcement-bar--animate-in, .announcement-bar--animate-out, .announcement-bar {
            transition: all ${announcementBar.config.transitionDuration}ms;
        }
    </style>`
	);
};
// Set slide interval based on our slide duration
p80.announcementBar.prototype.createInterval = function () {
	const announcementBar = this;
	announcementBar.interval = setInterval(
		announcementBar.nextSlide.bind(announcementBar),
		announcementBar.config.slideDuration
	);
};
p80.announcementBar.prototype.nextSlide = function () {
	const announcementBar = this;
	announcementBar.previousSlide = announcementBar.currentSlide;
	// Reset our slide index when we reach the end
	if (announcementBar.currentSlide === announcementBar.totalSlides - 1) {
		announcementBar.currentSlide = 0;
	}
	// Otherwise increment
	else {
		announcementBar.currentSlide += 1;
	}

	// Animate out our current slide
	announcementBar.slides[announcementBar.previousSlide].classList.add(
		'announcement-bar--animate-out'
	);

	setTimeout(function () {
		// Hide our current slide and reset classes
		announcementBar.slides[announcementBar.previousSlide].classList.add(
			'announcement-bar--hidden'
		);
		announcementBar.slides[announcementBar.previousSlide].classList.remove(
			'announcement-bar--animate-out'
		);
		// Show our next slide
		announcementBar.slides[announcementBar.currentSlide].classList.remove(
			'announcement-bar--hidden'
		);
		announcementBar.slides[announcementBar.currentSlide].classList.add(
			'announcement-bar--animate-in'
		);

		// Reset the classes on our slides after the animation duration
		setTimeout(function () {
			announcementBar.slides[announcementBar.previousSlide].classList.remove(
				'announcement-bar--visible'
			);
			announcementBar.slides[announcementBar.currentSlide].classList.add(
				'announcement-bar--visible'
			);
			announcementBar.slides[announcementBar.currentSlide].classList.remove(
				'announcement-bar--animate-in'
			);
		}, announcementBar.config.transitionDuration);
	}, announcementBar.config.transitionDuration);
};
